import React from "react";
import { render } from "react-dom";

import NowOnBruzz from "./NowOnBruzz";

const container = document.querySelector("[data-now-on-bruzz]");
if (container) render(<NowOnBruzz type={container.dataset.type} />, container);
